import { useWorkspaceContext } from "@/contexts/WorkspaceContext";

export function useCurrentWorkspace() {
    const { currentWorkspace, currentWorkspaceUsage, apiKey, switchWorkspace } =
        useWorkspaceContext();
    return { currentWorkspace, currentWorkspaceUsage, apiKey, switchWorkspace };
}
